export default {
  headline: "QR-Code Scannen",
  error: {
    headline: "Fehler",
    no_assignment: "Der QR-Code konnte keinem Formular zugeordnet werden!",
    token_invalid: "Dieser QR-Code ist nicht gütlig!"
  }
}
